// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';

import { CommandDO } from '../../../requests';

interface Props {
  formValues: {
    data: Partial<CommandDO>;
  };
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

/**
 * Function to generate a form component
 *
 * @param props properties of the component
 * @returns jsx element with the form
 */
function Form(props: Props): JSX.Element {
  const { data } = props.formValues;

  return (
    <fieldset>
      <div className="row">
        <div className="col-6">
          <label className="label">
            <b>Name</b> &nbsp;
          </label>
          <input
            className="inputNew"
            style={{ width: '80%' }}
            type="text"
            value={data.name || ''}
            name="name"
            onChange={props.onChange}
            required
          />
          <label>&nbsp;&nbsp;*</label>
        </div>
        <div className="col-6">
          <label className="label">
            <b>Command</b> &nbsp;
          </label>
          <input
            className="inputNew"
            style={{ width: '80%' }}
            type="text"
            value={data.value || ''}
            name="value"
            onChange={props.onChange}
            required
          />
          <label>&nbsp;&nbsp;*</label>
        </div>
      </div>
      <br />
    </fieldset>
  );
}

export default Form;
